import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@ps/ds/lib/utils'
import { CardContent, Card as ShadCard } from '@ps/ds/ui/card'

export interface CardProps extends Omit<ComponentPropsWithoutRef<typeof ShadCard>, 'title'> {}

export function Card({ className, children, ...props }: CardProps) {
  return (
    <ShadCard className={cn('w-full', className)} {...props}>
      {children}
    </ShadCard>
  )
}

export { CardContent }
export {
  CardHeader,
  CardHeaderContainer,
  CardHeaderDescription,
  CardHeaderProgress,
  CardHeaderTitle,
  type CardHeaderPadding,
  type CardHeaderProps,
  type CardHeaderSize,
} from '@ps/ds/components/primitives/CardHeader/CardHeader'
export {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
  type CardFooterPadding,
  type CardFooterProps,
  type CardFooterLeftProps,
  type CardFooterRightProps,
  type CardFooterVariant,
} from '@ps/ds/components/primitives/CardFooter/CardFooter'
